import { Navigate } from "react-router-dom";
import { useLoginStore } from "../store/useLoginStore";
import { useAuth } from "../store/useAuthStore";
import { ROLES, type Role } from "../types/auth.types";

export default function MainPage() {
  const { access } = useLoginStore();
  const auth = useAuth((state) => state.auth);
  const currentUserRole: string | { [key in Role]?: string } = auth.role;

  if (!access) return <Navigate to={"/login"} replace />

  switch (currentUserRole) {
    case ROLES.ADMIN:
    case ROLES.PARTNER:
    case ROLES.OWNER:
      return <Navigate to={"/quotation"} replace />
    case ROLES.USER:
    case ROLES.ALL:
      return <Navigate to={"/login"} replace />
  }
}